// extracted by mini-css-extract-plugin
module.exports = {"artistBio":"profile-ProfileAbout__artistBio--3RGg4"};